<template>
  <v-data-table
    v-model="selectedBody2Cars"
    :headers="headers"
    :items="body2Cars"
    :search="search"
    :loading="isTableLoading"
    item-key="id"
    multi-sort
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-btn
          color="primary"
          class="m-2"
          @click="loadBody2"
        >
          <v-icon left>
            mdi-refresh
          </v-icon>
          更新
        </v-btn>
        <v-btn
          color="primary"
          class="m-2"
          @click="downloadBody2"
        >
          <v-icon left>
            mdi-download
          </v-icon>
          下載
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clear-icon="mdi-close-circle"
          label="Search"
          clearable
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
  </v-data-table>
</template>

<script>
import { saveAs } from 'file-saver';

export default {
  data() {
    return {
      body2Cars: [],
      isTableLoading: false,
      search: '',
      headers: [
        {
          text: '車牌',
          value: 'licensePlate',
          width: '30%',
        },
        {
          text: '開始日期',
          value: 'beginDate',
          width: '25%',
        },
        {
          text: '結束日期',
          value: 'endDate',
          width: '25%',
        },
        {
          text: '來源',
          value: 'operator',
          width: '20%',
        }
      ],
    }
  },

  computed: {
  },

  created () {
    this.loadBody2();
  },

  methods: {
    loadBody2() {
      this.isTableLoading = true;
      this.licensePlates = [];
      this.axios.get('api/body2')
        .then((resp) => {
          this.body2Cars = [];
          resp.data.forEach(item => {
            this.body2Cars.push({
              id: item.id,
              licensePlate: item.licensePlate,
              beginDate: item.begin_date,
              endDate: item.end_date,
              operator: item.operator,
              isSelectable: item.operator === 'user'? true: false,
            });
          });
        })
        .catch(err => alert(err))
        .then(() => this.isTableLoading = false);
    },
    downloadBody2() {
      const data = this.body2Cars.map((item) => Object.values(item).join(',')).join(',\r\n');
      const blob = new Blob([data], {type: 'text/plaian;charset=utf-8'})

      saveAs(blob, '市外身障車.csv');
    },
  },
}
</script>
